import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import InnerCli2Img from '@/assets/inner-cli2.svg';
import InnerCli3Img from '@/assets/inner-cli3.svg';
import InnerCli4Img from '@/assets/inner-cli4.svg';

import css from './index.module.less';

export function FeaturesSection() {
  const { t } = useTranslation();

  const FEATURES = [
    {
      title: t('cli.inner.features.card1.title'),
      description: t('cli.inner.features.card1.description'),
      image: InnerCli2Img,
    },
    {
      title: t('cli.inner.features.card2.title'),
      description: t('cli.inner.features.card2.description'),
      image: InnerCli3Img,
    },
    {
      title: t('cli.inner.features.card3.title'),
      description: t('cli.inner.features.card3.description'),
      image: InnerCli4Img,
    },
  ];
  return (
    <div
      className={clsx(
        css['features-container'],
        'flex flex-col md:flex-row md:flex-wrap xl:flex-row xl:flex-nowrap',
      )}
    >
      {FEATURES.map((feature, index) => (
        <div key={index} className={clsx(css['feature-card'])}>
          <div className={clsx(css['feature-text'])}>
            <h3 className={clsx(css['feature-title'])}>{feature.title}</h3>
            <p className={clsx(css['feature-description'])}>{feature.description}</p>
          </div>
          <img src={feature.image} alt={feature.title} className={clsx(css['feature-image'])} />
        </div>
      ))}
    </div>
  );
}
